module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/ig-circle-256.74a44685a61cb176.png"+" 256w",
        images: [{path: "https://static.sniffspot.com/packs/img/ig-circle-256.74a44685a61cb176.png",width: 256,height: 256}],
        src: "https://static.sniffspot.com/packs/img/ig-circle-256.74a44685a61cb176.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/ig-circle-256.74a44685a61cb176.png"},
        
        width: 256,
        height: 256
      }